import { defineMessages } from 'react-intl-next';

export const messages: {
	channelMemberCount: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	channelTypeLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	externalPeopleText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	externalPersonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	lastActive: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	messageTypeLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	noContributorsText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	privateConversationText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	threadTypeLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titleAndChannelName: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titleWithRemainingContributors: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	lastActive: {
		id: 'search-page.results.product-results.third-party.last-active',
		defaultMessage: 'Last active {relativeDate}',
		description:
			'Label for the last active time Slack metadata which shows the last time the content was active. Located in the search results in the Dynamic Search modal when a user is updating content search filters',
	},
	threadTypeLabel: {
		id: 'search-page.results.product-results.third-party.thread-type-label',
		defaultMessage: 'Thread',
		description:
			'Label for the Thread Slack metadata which shows the thread content. Located in the search results in the Dynamic Search modal when a user is updating content search filters',
	},
	messageTypeLabel: {
		id: 'search-page.results.product-results.third-party.message-type-label',
		defaultMessage: 'Message',
		description:
			'Label for the Message Slack metadata which shows the message content. Located in the search results in the Dynamic Search modal when a user is updating content search filters',
	},
	channelTypeLabel: {
		id: 'search-page.results.product-results.third-party.channel-type-label',
		defaultMessage: 'Channel',
		description:
			'Label for the Channel Slack metadata which shows the channel content. Located in the search results in the Dynamic Search modal when a user is updating content search filters',
	},
	channelMemberCount: {
		id: 'search-page.results.product-results.third-party.channel-member-count',
		defaultMessage: '{memberCount, plural, one {# member} other {# members}}',
		description:
			'Label for the number of members in a Slack channel. Located in the search results in the Dynamic Search modal when a user is updating content search filters',
	},
	privateConversationText: {
		id: 'search-page.results.product-results.third-party.private-conversation-text',
		defaultMessage: '{users} in a private conversation',
		description:
			'Label for a private conversation in Slack. It also indicates how many users are in the private conversartion. Located in the search results in the Dynamic Search modal when a user is updating content search filters',
	},
	noContributorsText: {
		id: 'search-page.results.product-results.third-party.no-contributors-label',
		defaultMessage: 'External people in #{channelName}',
		description:
			'Text for no Slack contributors metadata shown in the search result title. Located in the search results in the Dynamic Search modal when a user is updating content search filters',
	},
	externalPeopleText: {
		id: 'search-page.results.product-results.third-party.external-people-label',
		defaultMessage: 'External people',
		description:
			'Text indicating that external people are part of the data in the search result title. Located in the search results in the Dynamic Search modal when a user is updating content search filters',
	},
	externalPersonText: {
		id: 'search-page.results.product-results.third-party.external-person-label',
		defaultMessage: 'External person',
		description:
			'Text indicating that an external person is part of the data in the search result title. Located in the search results in the Dynamic Search modal when a user is updating content search filters',
	},
	titleWithRemainingContributors: {
		id: 'search-page.results.product-results.third-party.title-with-remaining-contributors',
		defaultMessage:
			'{title} and {remainingContributorsCount} {remainingContributorsCount, plural, one {other} other {others}}',
		description:
			'Label for the title that also contains number of remaining contributors in the content. Located in the search results in the Dynamic Search modal when a user is updating content search filter. ',
	},
	titleAndChannelName: {
		id: 'search-page.results.product-results.third-party.title-and-channel-name',
		defaultMessage: '{title} in #{channelName}',
		description:
			'Label for the title and Slack channel name.Located in the search results in the Dynamic Search modal when a user is updating content search filter.',
	},
});
